import { Box, Container } from '@chakra-ui/react';

import { useLocation, useParams, useSearchParams } from 'react-router-dom';
import EmptyAlert from '../../emptyAlert/EmptyAlert';
import findRoute from '../../../utils/findRoute';
import { useGetProductTypesQuery } from '../../../redux/platimarket/platimarket.api';
import ProductTypesList from './components/productTypesList/ProductTypesList';
import Loader from '../../loader/Loader';

export default function ProductTypes() {
    const location = useLocation();
    const pathName = location.pathname;

    const findedRoute = findRoute(pathName);
    const emptyMessage = findedRoute?.emptyMessage;

    const params = useParams();
    const productId = Number(params.productId);

    const { data: productTypes, isLoading: isLoadingProductTypes } = useGetProductTypesQuery({
        id: productId,
    });

    const isProductTypes = !!productTypes?.length;

    return (
        <Container>
            {isLoadingProductTypes && (
                <Box display="flex" justifyContent="center" mt="30px">
                    <Loader />
                </Box>
            )}

            {isProductTypes && (
                <ProductTypesList
                    productTypes={productTypes}
                    productId={productId}></ProductTypesList>
            )}

            {!isProductTypes && !isLoadingProductTypes && (
                <EmptyAlert localeMessage={emptyMessage} />
            )}
        </Container>
    );
}
